import { render, staticRenderFns } from "./h5Upload.vue?vue&type=template&id=5dc22038&scoped=true"
import script from "./h5Upload.vue?vue&type=script&lang=js"
export * from "./h5Upload.vue?vue&type=script&lang=js"
import style0 from "./h5Upload.vue?vue&type=style&index=0&id=5dc22038&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc22038",
  null
  
)

export default component.exports